import { memo } from 'react';
import { LobbyWidget } from '@bonanza-social/moonlight';
import { StackNavigationProp, useNavigation } from '@bonanza-social/navigation';
import { useTranslation } from '@bonanza-social/i18n';

function PlayWithCoinsLobbyWIdget() {
  const [t] = useTranslation('games');
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const handleClick = () => {
    navigation.navigate('PlayWithCoinsScreen');
  };

  return (
    <LobbyWidget
      image="games.lobbyWidgetIcon"
      label={t('widgetLabel')}
      onClick={handleClick}
    />
  );
}

export default memo(PlayWithCoinsLobbyWIdget);
